import { useMemo, useState } from 'react';
import { useGetWorkflowCategories } from '../../../../../../services/workflow.services';
import { Select } from '@mantine/core';
import { IoIosArrowDown } from 'react-icons/io';
import { ExtractionDrawer } from './TransformationTypes/Join/ExtractionsDrawer';

export function SearchSelect({
  id,
  onSelect,
  label,
  value,
  placeholder,
  year,
  periodName,
  workflowName,
  selectedTableName,
  periodId
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [hasDataFetched, setHasDataFetched] = useState(false);

  const { data, isLoading } = useGetWorkflowCategories({
    queryParams: {
      enabled: !!isOpen && !hasDataFetched,
      onSuccess: () => {
        setHasDataFetched(true);
      }
    }
  });
  const foundWorkflow = useMemo(() => {
    if (!data) return null;

    return data?.find(item => item.id === value);
  }, [data, value]);

  return (
    <>
      <Select
        id={id || 'grid-table-search-select'}
        value={selectedTableName}
        data={[selectedTableName].filter(el => el)}
        onClick={() => setIsOpen(prev => !prev)}
        dropdownOpened={false}
        size="sm"
        label={label}
        rightSection={<IoIosArrowDown />}
        placeholder={placeholder}
      />

      <ExtractionDrawer
        id={id ? `${id}-drawer` : 'grid-table-search-select-drawer'}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        workflowName={foundWorkflow?.workflow_name || workflowName}
        period={foundWorkflow?.period || periodName}
        year={foundWorkflow?.year || year}
        value={value}
        selectedTableName={selectedTableName}
        onSelectExtraction={onSelect}
        replicateExtractionList={{ data, isLoading }}
        periodId={periodId}
      />
    </>
  );
}
